"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertListComponent = exports.getGroupedAlerts = exports.getContainerHeight = exports.ALERT_ITEM_HEIGHT = exports.ALERT_CONTAINER_MAX_HEIGHT = exports.ALERT_CONTAINER_MIN_HEIGHT = void 0;
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var styles = require("../styles/DataAlerts");
var AlertDetailComponent_1 = require("./AlertDetailComponent");
exports.ALERT_CONTAINER_MIN_HEIGHT = 300;
exports.ALERT_CONTAINER_MAX_HEIGHT = 550;
exports.ALERT_ITEM_HEIGHT = 50;
var getContainerHeight = function (groupAlerts) {
    var _a;
    var lenArr = Object.values(groupAlerts).map(function (n) { return n.length; });
    var maxAlertItemsLength = lenArr.length ? Math.max.apply(Math, lenArr) : 0;
    var alertContainerHeight = (_a = maxAlertItemsLength * exports.ALERT_ITEM_HEIGHT) !== null && _a !== void 0 ? _a : 0;
    var height = Math.max(alertContainerHeight, exports.ALERT_CONTAINER_MIN_HEIGHT);
    return Math.min(height, exports.ALERT_CONTAINER_MAX_HEIGHT); // define max
};
exports.getContainerHeight = getContainerHeight;
var getGroupedAlerts = function (alerts) {
    return alerts.reduce(function (reducedAlerts, currAlert) {
        reducedAlerts[currAlert.subject] = reducedAlerts[currAlert.subject] || [];
        reducedAlerts[currAlert.subject].push(currAlert);
        return reducedAlerts;
    }, {});
};
exports.getGroupedAlerts = getGroupedAlerts;
var AlertListComponent = function (props) {
    var _a = React.useState(0), selectedIndex = _a[0], setSelectedIndex = _a[1];
    var alerts = props.alerts, isImprovement = props.isImprovement;
    var groupAlerts = exports.getGroupedAlerts(alerts);
    var alertKeys = Object.keys(groupAlerts);
    var onAlertClick = function (index) {
        if (index < 0 || index >= props.alerts.length) {
            return;
        }
        if (index !== selectedIndex) {
            setSelectedIndex(index);
        }
    };
    var renderAlertRecommendationList = function () {
        if (!(alertKeys === null || alertKeys === void 0 ? void 0 : alertKeys.length)) {
            return React.createElement("div", { className: styles.emptyAlertPlaceholder }, Localize_1.Messages.NoAlertsAvailable());
        }
        return (React.createElement("div", { className: styles.alertListItemStyle }, alertKeys.map(function (alertKey, index) {
            var highlightedStyle = index === selectedIndex ? styles.alertListSelectedStyle : '';
            return (React.createElement("div", { key: index, className: styles.alertListTextStyle + " " + highlightedStyle, onClick: function () { return onAlertClick(index); }, role: "button", "aria-hidden": "true" },
                React.createElement("div", null, alertKey),
                React.createElement("div", null, ">")));
        })));
    };
    // TODO: post alpha for actions column
    // const renderAlertStatusList
    var renderAlertDetail = function () {
        var alerts = groupAlerts[alertKeys[selectedIndex]];
        if (!alerts) {
            return null;
        }
        return (React.createElement("div", { className: styles.alertDetailItemStyle, style: { height: exports.getContainerHeight(groupAlerts) } },
            React.createElement("ul", { className: styles.alertUnOrderListStyle }, alerts.map(function (alert, index) {
                return (React.createElement("li", { key: index, className: styles.alertListDetailStyle },
                    React.createElement("div", { className: styles.alertListDetailTextStyle }, alertKeys[selectedIndex]),
                    React.createElement("div", { className: styles.alertListDetailTextStyle }, alert.message),
                    React.createElement(AlertDetailComponent_1.AlertDetailComponent, { alert: alert, hidden: isImprovement, color: props.color })));
            }))));
    };
    var renderAlertList = function () {
        return (React.createElement("div", { className: styles.alertContainerStyle + " " + (props.hideBorder ? '' : styles.alertBorder) },
            React.createElement("div", { className: styles.alertListRecommendationContainerStyle },
                React.createElement("div", { className: styles.alertListHeaderStyle }, Localize_1.Messages.AlertRecommendation()),
                renderAlertRecommendationList()),
            React.createElement("div", { className: styles.alertListDetailContainerStyle },
                React.createElement("div", { className: styles.alertListHeaderStyle }, Localize_1.Messages.AlertDefinition()),
                renderAlertDetail())));
    };
    return renderAlertList();
};
exports.AlertListComponent = AlertListComponent;
//# sourceMappingURL=AlertListComponent.js.map